export function normalizeToMapPoints(data, type) {
  return data
    .map(item => {
      const lat = Number(
        item.latitude ??
        item.lat
      );

      const lng = Number(
        item.longitude ??
        item.lng ??
        item.lon
      );

      return {
        latitude: Number.isFinite(lat) ? lat : null,
        longitude: Number.isFinite(lng) ? lng : null,
        name: item.name ?? item.title ?? "Unnamed",
        info: item.info ?? "",
        // for the detail panel (PoiInfoPanel) when the point is clicked
        description: item.description ?? item.info ?? "",
        imageUrl: item.image_url ?? null,
        // category icon (map marker), see 0019_category_icon.sql
        iconUrl: item.icon_url ?? item.iconUrl ?? null,
        type: type,
      };
    })
    .filter(point =>
      Number.isFinite(point.latitude) &&
      Number.isFinite(point.longitude)
    );
}


export function normalizePOO(data) {
  return data
    .map(item => ({
      name: item.name,

      latitude: Number(item.latitude),
      longitude: Number(item.longitude),

      color: item.color_hex ?? "#000000",
      fontSize: Number(item.font_size ?? 14),
      fontWeight: item.font_weight ?? "normal",
      fontStyle: item.font_style ?? "normal",

      minZoom: Number(item.zoom_min ?? 12),
      maxZoom: Number(item.zoom_max ?? 20),

      opacity: Number(item.opacity ?? 1),
      zIndex: item.z_index ?? 0,

      iconName: item.icon_name,
      iconColor: item.icon_color,
      imageUrl: item.image_url ?? null,
      description: item.description ?? ""
    }))
    .filter(
      p =>
        Number.isFinite(p.latitude) &&
        Number.isFinite(p.longitude)
    );
}

// listing rows (Gastronomie, Ferienhäuser) -> shape used by PoiInfoPanel
export function normalizeListing(data) {
  return data.map(item => ({
    id: item.id,
    key: `listing-${item.id}`,
    categoryId: item.category_id ?? null,
    iconUrl: item.icon_url ?? null,
    latitude: item.latitude,
    longitude: item.longitude,
    name: item.name ?? "Unnamed",
    description: item.description ?? "",
    imageUrl: item.image_url ?? null,
    address: item.address ?? null,
    phone: item.phone ?? null,
    email: item.email ?? null,
    url: item.url ?? null,
  }));
}
